'use client'

import type { AitypesInsight } from '@polaris/api-client'
import { cn } from '@/src/utils/styles'
import { Badge } from '../ui/badge'
import { InsightCardLink } from '../ui/insights/insight-card-link'
import { InsightCardSubject } from '../ui/insights/insight-card-subject'
import { InsightImage } from '../ui/insights/insight-image'
import { TokenPriceIndicator } from './token-price-indicator'

interface FeaturedInsightCardProps {
  insight: AitypesInsight
  className?: string
}

export const FeaturedInsightCardSkeleton = () => {
  return (
    <div className='group flex flex-col sm:flex-row rounded-2xl overflow-hidden max-w-[960px] w-full bg-tertiary h-[320px] animate-pulse' />
  )
}

export function FeaturedInsightCard({
  insight,
  className,
}: FeaturedInsightCardProps) {
  return (
    <InsightCardLink insight={{ ...insight, highlight: true }}>
      <div
        className={cn(
          'group flex flex-col sm:flex-row rounded-2xl overflow-hidden max-w-[960px] w-full',
          className,
        )}
      >
        <div className='flex-1 min-w-0 relative'>
          <InsightImage insight={insight} variant='featured' />
        </div>

        <div
          className='flex-1 min-w-0 bg-foreground flex flex-col gap-3 px-6 py-4 sm:min-h-80 relative'
          style={{
            boxShadow: '0px 0px 64px 80px var(--foreground)',
          }}
        >
          <div className='flex-1 flex flex-col gap-3'>
            <Badge className='self-start'>Today’s highlight</Badge>
            <h2 className='text-3xl leading-9 text-primary font-extralight font-serif'>
              {insight.headline}
            </h2>
          </div>

          <div className='flex gap-1 items-center'>
            <InsightCardSubject insight={insight} variant='v2' />
            {insight.subjectSelector && (
              <TokenPriceIndicator
                chainId={insight.subjectValue?.chainId}
                denom={insight.subjectValue?.denom}
              />
            )}
          </div>
        </div>
      </div>
    </InsightCardLink>
  )
}
